import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShoppingBag } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  scrollTo?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  href,
  scrollTo
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  const linkHref = href || 'http://checkout.pixastore.online/cart/42406778339422:1';
  const isExternal = !scrollTo;
  return <motion.a href={linkHref} onClick={handleClick} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`
        inline-flex items-center justify-center gap-1.5
        bg-gradient-to-r from-pink-500 to-purple-600 
        text-white font-bold text-xs uppercase tracking-wide
        py-2 px-5 rounded-full shadow-md
        hover:shadow-lg hover:scale-105
        transition-all duration-300 ease-out
        border-b-2 border-pink-700 active:border-b-0 active:translate-y-0.5
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} data-id="element-13">
      {children}
    </motion.a>;
}